import { combineReducers } from "redux";
import { userguideState } from "./userguideReducer";

export const userguideReducer = combineReducers({
    userguideState: userguideState
});
